import { useState } from "react";

function formatDuration(seconds = 0) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
}

function formatDateTime(value) {
  return value ? new Date(value).toLocaleString() : "—";
}

export default function SessionLogTable({ rows = [], totalRows, onExportCsv, onExportReport, isExporting, isReportExporting }) {
  const [visibleCount, setVisibleCount] = useState(10);
  const visibleRows = rows.slice(0, visibleCount);

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-lg font-semibold text-slate-950">Session log</h2>
          <p className="text-sm text-slate-500">
            Unique viewers (one per browser) combined across repeat visits.
            {totalRows > rows.length && ` Showing the latest ${rows.length} of ${totalRows}; export for the full log.`}
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={onExportCsv} disabled={isExporting} className="secondary-button">
            {isExporting ? "Exporting..." : "Export CSV"}
          </button>
          <button type="button" onClick={onExportReport} disabled={isReportExporting} className="secondary-button">
            {isReportExporting ? "Building report..." : "Download report"}
          </button>
        </div>
      </div>
      <div className="mt-5 overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-200 text-sm">
          <thead>
            <tr className="text-left text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
              <th className="py-3 pr-4">User #</th>
              <th className="px-4 py-3">First joined</th>
              <th className="px-4 py-3">Left session</th>
              <th className="px-4 py-3">Sessions</th>
              <th className="px-4 py-3">Total duration</th>
              <th className="px-4 py-3">Watch time</th>
              <th className="px-4 py-3">Watch %</th>
              <th className="px-4 py-3">Country</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {visibleRows.map((row) => (
              <tr key={row.viewer_key || row.user_number}>
                <td className="py-3 pr-4 font-mono text-slate-700">#{row.user_number}</td>
                <td className="px-4 py-3 text-slate-600">{formatDateTime(row.joined_at)}</td>
                <td className="px-4 py-3 text-slate-600">{formatDateTime(row.left_at)}</td>
                <td className="px-4 py-3 font-mono text-slate-700">{row.session_count}</td>
                <td className="px-4 py-3 font-mono text-slate-700">{formatDuration(row.duration_seconds)}</td>
                <td className="px-4 py-3 font-mono text-slate-700">{formatDuration(row.watch_duration_seconds)}</td>
                <td className="px-4 py-3 font-mono text-slate-700">{row.watch_percentage}%</td>
                <td className="px-4 py-3 text-slate-700">{row.country}</td>
              </tr>
            ))}
            {!rows.length && (
              <tr><td className="py-4 text-slate-500" colSpan="8">No sessions yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
      {visibleCount < rows.length && (
        <button type="button" className="secondary-button mt-4" onClick={() => setVisibleCount((count) => count + 10)}>
          Load more
        </button>
      )}
    </section>
  );
}
